import { render, staticRenderFns } from "./resultBrightnessGuide.vue?vue&type=template&id=4128bfc6&scoped=true&"
import script from "./resultBrightnessGuide.vue?vue&type=script&lang=js&"
export * from "./resultBrightnessGuide.vue?vue&type=script&lang=js&"
import style0 from "./resultBrightnessGuide.vue?vue&type=style&index=0&id=4128bfc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4128bfc6",
  null
  
)

export default component.exports